import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicTabs from "./BasicTabs";
import ColoredTab from "./ColoredTab";
import DisabledTab from "./DisabledTab";
import FullWidthTab from "./FullWidthTab";
import CenteredTab from "./CenteredTab";
import ScrollableTabs from "./ScrollableTabs";
import VerticalTabs from "./VerticalTabs";

const TabsPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Tabs"}
        description={
          "Tabs make it easy to explore and switch between different views."
        }
      />
      <Divider light />

      <BasicTabs />
      <ColoredTab />
      <DisabledTab />
      <FullWidthTab />
      <CenteredTab />
      <ScrollableTabs />
      <VerticalTabs />
    </Paper>
  );
};

export default TabsPage;
